import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

/*
 * Constants.
 */

const sidePadding = 32;
export const PAGE_WIDTH = 600;
export const MOBILE_BREAKPOINT = PAGE_WIDTH + 2 * sidePadding;

/*
 * Props.
 */

export interface ConfigurableLayerProps {
  backgroundColor?: string;
}

/*
 * Style.
 */

interface SurveyPageWrapperDivProps {
  $backgroundColor?: string;
}

const SurveyPageWrapperDiv = styled.div<SurveyPageWrapperDivProps>`
  width: 100%;
  height: 100%;
  background-color: ${(p) => p.$backgroundColor};
  padding: 48px ${sidePadding}px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    align-items: stretch;
  }
`;

/*
 * Componenent.
 */

export const ConfigurableLayer: FC<PropsWithChildren<ConfigurableLayerProps>> = (props) => (
  <SurveyPageWrapperDiv $backgroundColor={props.backgroundColor}>{props.children}</SurveyPageWrapperDiv>
);
